export default {
  CLEAR_API_ERROR: 'CLEAR_API_ERROR',
  PUSH_API_ERROR: 'PUSH_API_ERROR',
  RESET_COMMON_STATE: 'RESET_COMMON_STATE',
  SET_COMMON_IS_LOADING: 'SET_COMMON_IS_LOADING',
  SET_REDIRECTING_TO: 'SET_REDIRECTING_TO',
  SET_USER_CONTEXT: 'SET_USER_CONTEXT',
  FETCH_FORM_TYPES: 'FETCH_FORM_TYPES',
};
